import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import IntNumberFormatInput from '../../int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },

});

class EditTipoFichaSub extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.tipoFichaSub.id ? this.props.tipoFichaSub.id : uuidv4(),
            descr: this.props.tipoFichaSub.descr ? this.props.tipoFichaSub.descr : '',
            factor: this.props.tipoFichaSub.factor ? this.props.tipoFichaSub.factor : 1,
            iTipoficha: this.props.tipoFichaSub.iTipoficha ? this.props.tipoFichaSub.iTipoficha : this.props.tipoFichaList[0].id,
            tipoFichaDescr: this.props.tipoFichaSub.tipoFichaDescr ? this.props.tipoFichaSub.tipoFichaDescr : this.props.tipoFichaList[0].descr,
        }

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };

    compareDescr = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    fillSelectOptionList = () => {

        return this.props.tipoFichaList.sort(this.compareDescr).map(tf => {
            return (
                <option key={tf.id} value={tf.id}>{tf.descr}</option>
            );
        });

    };

    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoficha: value,
            tipoFichaDescr: this.props.tipoFichaList.find(tf => tf.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={(event) => this.handleValueChange(event, 'descr')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <Tooltip title="Número de puntos asociados a esta ficha" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'factor'}
                                label={'Factor'}
                                placeholder={'Factor'}
                                className={classes.textField}
                                margin="normal"
                                InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                                value={this.state.factor}
                                onChange={(event) => this.handleValueChange(event, 'factor')}
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={`${classes.containerPair} ${classes.margin}`}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipo-ficha-placeholder">
                            Tipo Ficha
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoficha}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoFichaSub = {
                            id: this.state.id,
                            descr: this.state.descr,
                            factor: this.state.factor,
                            tipoFichaDescr: this.state.tipoFichaDescr,
                            iTipoficha: this.state.iTipoficha
                        }

                        if (this.props.checkTipoFichaSub(tipoFichaSub)) {

                            this.props.okHandler(tipoFichaSub);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    }

};

EditTipoFichaSub.propTypes = {
    tipoFichaSub: PropTypes.object.isRequired,
    checkTipoFichaSub: PropTypes.func.isRequired,
    tipoFichaList: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditTipoFichaSub);